import { BlockBuilder, ContextMenu, Resize } from 'modules'
import { resizerSelectors } from 'selectors'

type InitProps = {
	onInit?: () => void
	onResizeComplete?: () => void
	onWindowResize?: () => void
}

export const AbstractResizer = (() => {
	const rsz = Resize()
	const bb = BlockBuilder()

	const initContextMenu = (active = rsz.getActive()) => {
		const items = resizerSelectors.getItems()

		if (!items) {
			return
		}
		const { length } = items
		for (let i = 0; i < length; i++) {
			const item = items[i]
			const contextMenu = ContextMenu()
			contextMenu.init({
				scope: resizerSelectors.getItemBlock(item),
				items: window.editorBlockContextMenu,
				active,
			})
		}
	}

	const init = ({ onInit }: InitProps) => {
		bb.init()

		rsz.init({
			onInit,
			onActivate: () => {
				bb.show()
			},
			onDeactivate: () => {
				bb.hide()
			},
			onResizeActiveChange: (active) => {
				initContextMenu(active)
			},
		})
	}

	const isMobile = () => Math.min(window.screen.width, window.screen.height) < 768

	return {
		makeLoading: rsz.makeLoading,
		initSizes: rsz.initSizes,
		init,
		initContextMenu,
		getSizes: rsz.getSizes,
		destroyLoading: rsz.destroyLoading,
		destroyResizerLoading: rsz.destroyResizerLoading,
		isMobile,
	}
})()
